// export const DEV = "http://15.207.107.52:3000/api";
// export const DEV = "https://api-dev.assertit.io /premind/api/"
export const DEV = "https://server.prempackaging.com/premind/api";

// export const DEV = "https://server.prempackaging.com/premind/api/";
